define(function (require, exports, module) {
    var ContentPhoto = require('./ContentPhoto');
    var ContentVideo = require('./ContentVideo');

    var EMPTY = '';
    var VIDEO = 'video';

    function ContentArticle (article) {
        this.id = article.id || article.slug;
        this.slug = article.slug;
        this.linkId = article.id ? 'c-' + article.id : article.slug;
        this.headline = article.headline || EMPTY;
        this.body = article.body || EMPTY;
        this.blurb = article.blurb || EMPTY;
        if (article.photo) {
            this.photo = new ContentPhoto(article.photo);
        }
        if (article.media && article.media.type === VIDEO) {
            this.video = new ContentVideo(article.media);
        }
    }

    ContentArticle.prototype = {

    };

    return ContentArticle;
});
